class ResetFrameFinder extends HTMLElement {
    connectedCallback() {
        const resetLink = this.querySelector('[data-reset="reset"]'); // Target il data attribute 'data-reset'
        if (resetLink) {
            resetLink.addEventListener('click', (event) => {
                event.preventDefault();
                this.reset();
            });
        }
    }

    reset() {
        const collectionUrl = this.dataset.collection;

        if (!collectionUrl) return;

        // Resetta localStorage e cookie
        localStorage.clear();
        CookieUtils.deleteCookie('frame_finder_filter_url');

        // Reindirizza all'URL della collezione
        window.location.href = collectionUrl;
    }
}

customElements.define('reset-frame-finder', ResetFrameFinder);
